import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const ListMobileAppConfiguration=()=>request({
    url: ApiURL.Query.GetListMobileConfiguration,
    method: RequestType.GET,
   });
   const ListMobileAppConfigurationV2=(params:any)=>request({
    url: ApiURL.Query.GetListMobileConfigurationV2+"?countryId="+params,
    method: RequestType.GET,
   });

   const MobilePanelConfigurationQuery = {
    ListMobileAppConfiguration,
    ListMobileAppConfigurationV2
  };
  
  export default MobilePanelConfigurationQuery;